import { dateFormatter, dateComparator } from '@store/loadboard/utils';
import { formatAmount } from '@utils/utils';
import { ColDef } from '@ag-grid-community/core';

const commonFilterParams = {
  suppressAndOrCondition: true,
  filterOptions: ['startsWith'],
  buttons: ['apply', 'reset'],
};

const formatAccountingAmount = (value: number): string => {
  const absVal = formatAmount(Math.abs(value));
  return value < 0 ? `(${absVal})` : absVal;
};

export const dormantColumnDefs: ColDef[] = [
  {
    field: 'customerName',
    headerName: 'Customer',
    filter: 'agTextColumnFilter',
    minWidth: 150,
    filterParams: commonFilterParams,
    autoHeight: true,
    wrapText: true,
  },
  {
    field: 'accountManager',
    headerName: 'Account Manager',
    filter: 'agTextColumnFilter',
    minWidth: 173,
    filterParams: commonFilterParams,
    autoHeight: true,
  },
  {
    field: 'office',
    headerName: 'Office',
    minWidth: 150,
    filter: 'agTextColumnFilter',
    filterParams: commonFilterParams,
    autoHeight: true,
  },

  {
    field: 'lastOrder',
    headerName: 'Last Order Date',
    minWidth: 160,
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
    filterParams: {
      comparator: dateComparator,
      suppressAndOrCondition: true,
      filterOptions: ['equals', 'lessThan', 'greaterThan'],
      buttons: ['apply', 'reset'],
      minValidYear: 1900,
      maxValidYear: new Date().getFullYear() + 1,
    },
    autoHeight: true,
  },
  {
    field: 'monthsSinceLastOrder',
    headerName: 'Months Idle',
    filter: 'agNumberColumnFilter',
    minWidth: 130,
    filterParams: {
      filterOptions: ['equals', 'lessThanOrEqual', 'greaterThan'],
      suppressAndOrCondition: true,
      buttons: ['apply', 'reset'],
    },
    maxWidth: 150,
    autoHeight: true,
  },
  {
    field: 'openBalance',
    headerName: 'Open Balance',
    filter: 'agNumberColumnFilter',
    minWidth: 130,
    valueFormatter: (params) => {
      return formatAccountingAmount(params.value as number);
    },
    filterParams: commonFilterParams,
    autoHeight: true,
  },
  {
    field: 'creditLimit',
    headerName: 'Credit Limit',
    filter: 'agNumberColumnFilter',
    minWidth: 130,
    valueFormatter: (params) => {
      return formatAccountingAmount(params.value as number);
    },
    filterParams: commonFilterParams,
    autoHeight: true,
  },
  {
    field: 'seasonality',
    headerName: 'Customer Seasonality',
    filter: 'agSetColumnFilter',
    minWidth: 160,
    filterParams: {
      buttons: ['apply', 'reset'],
      suppressAndOrCondition: true,
      values: ['Unknown', 'Yes', 'No'],
    },
    autoHeight: true,
  },
];
